define('../app/fukit/model/tenant.model',['require','exports','module','./admin.base.model'],function(require, exports, module) {
  var AdminBaseModel = require('./admin.base.model');

  var TenantModel = AdminBaseModel.extend({
    radioRequests: {
      'models TenantModel': '@constructor',
    },
    urlRoot: AdminBaseModel.prototype.baseUrlRoot + '/tenant/tenant',
  });

  module.exports = TenantModel;
});

